import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import instantsearch from 'instantsearch.js/es';
import {
  refinementList,
  searchBox,
  stats,
  pagination,
  configure,
  sortBy,
  hits
} from 'instantsearch.js/es/widgets';

import newsItem from "../templates/news_item";
import meiliPagination from '../templates/meili_pagination';
import meiliStats from "../templates/meili_stats";

const paramsString = window.location.search;
const searchParams = new URLSearchParams(paramsString);
const currentPage = searchParams.get('page') ?? 1;
let searchKeyword = searchParams.get('keyword') ?? searchParams.get('search');

const instantsearchInstances = {};
document.querySelectorAll('[data-meilisearch]').forEach((el) => {
  const indexName = el.dataset.meilisearchIndex;
  const meiliHost = el.dataset.meilisearchHost;
  const meiliKey = el.dataset.meilisearchKey;
  const keyName = el.dataset.result;
  const locale = el.dataset.locale;
  const category = el.dataset.category;
  const perPage = el.dataset.limit ?? 6;
  const templateType = el.dataset.templateType ?? 'list';

  const selectorHits = `[data-result="${keyName}"]`;
  const selectorTab = `[data-tab="${keyName}"]`;
  const selectorSearch = `[data-search="${keyName}"]`;

  let viewLoaded = false;

  const client = instantMeiliSearch(meiliHost, meiliKey, {
    primaryKey: 'uid',
    finitePagination: true,
  }).searchClient;

  let cssClasses = {};
  if (templateType === 'grid-image') {
    cssClasses = {
      list: 'row',
      item: 'col-md-4 p-1',
    }
  }

  let filters = {};
  if (category) {
    filters = {
      refinementList: {
        category: [category],
      },
    };
  }

  const search = instantsearch({
    indexName: indexName,
    searchClient: client,
    initialUiState: {
      [indexName]: {
        query: searchKeyword,
        page: currentPage,
        sortBy: `${indexName}:postDate:desc`,
        ...filters,
      },
    },
  });

  const widgets = [];

  if (document.querySelector(`${selectorHits} [data-meilisearch-pagination-stats]`)) {
    widgets.push(
      stats({
        container: `${selectorHits} [data-meilisearch-pagination-stats]`,
        templates: {
          text: function(renderOptions, { html }) {
            return meiliPagination(
              renderOptions,
              { html },
              { locale, selectorTab }
            );
          }
        }
      })
    );
  }

  if (document.querySelector(`${selectorSearch} [data-meilisearch-stats]`)) {
    widgets.push(
      stats({
        container: `${selectorSearch} [data-meilisearch-stats]`,
        templates: {
          text: function (renderOptions, {html}) {
            return meiliStats(
              renderOptions,
              {html},
              {locale}
            );
          }
        }
      }),
    )
  }

  if (document.querySelector(`${selectorHits} [data-meilisearch-filter]`)) {
    widgets.push(
      refinementList({
        container: `${selectorHits} [data-meilisearch-filter]`,
        attribute: 'category',
        limit: 99999,
      }),
    )
  }

  if (document.querySelector(`${selectorSearch} [data-meilisearch-searchbox]`)) {
    let timerId;
    let timeout = 200; // debounce delay

    widgets.push(
      searchBox({
        container: `${selectorSearch} [data-meilisearch-searchbox]`,
        placeholder: 'Masukkan pencarian',
        showLoadingIndicator: true,
        cssClasses: {
          form: 'input-group',
          input: 'form-control h-100',
          submit: 'btn btn-warning px-3 ml-2',
          reset: 'btn btn-outline-dark px-3 ml-2',
        },
        queryHook(query, refinementQuery) {
          // add debounce to minimize query per second
          // see https://www.algolia.com/doc/guides/building-search-ui/going-further/improve-performance/js/#debouncing
          clearTimeout(timerId);
          timerId = setTimeout(() => {
            refinementQuery(query);

            // update other index result on update!
            updateOtherIndex(query, indexName, filters);
          }, timeout);
        }
      }),
    );
  }

  if (document.querySelector(`${selectorHits} [data-meilisearch-pagination]`)) {
    widgets.push(
      pagination({
        container: `${selectorHits} [data-meilisearch-pagination]`,
        padding: 2,
        showPrevious: false,
        showNext: false,
        cssClasses: {
          list: 'btn-group',
          item: 'btn btn-outline-primary',
          selectedItem: 'bg-primary text-light',
        },
      }),
    );
  }

  search.addWidgets([
    configure({
      hitsPerPage: perPage,
      limit: null,
    }),

    sortBy({
      container: `${selectorHits} [data-meilisearch-sort]`,
      items: [
        { label: 'Latest', value: 'postDate:desc' },
        { label: 'Oldest', value: 'postDate:asc' },
      ],
    }),
    ...widgets,
    hits({
      container: `${selectorHits} [data-meilisearch-items]`,
      cssClasses: cssClasses,
      templates: {
        empty: (hit, { html }) => {
          const isEnglish = locale === 'en';

          return html`
              <h3 class="text-center py-5">
                ${ isEnglish ? 'No entry found' : 'Tidak ada entri yang ditemukan' }
              </h3>
            `;
        },
        item: (hit, { html }) => {
          return newsItem(hit,
            { html },
            { locale, keyName, templateType }
          );
        }
      },
    })
  ]);

  // update lazyload images on search result rendered!
  search.on('render', () => {
    if (window.lazyloadInstance) {
      window.lazyloadInstance.update(); // update lazyload image
    }
  });

  search.start();

  search.setUiState({
    [indexName]: {
      query: searchKeyword,
      page: 1,
      sortBy: `${indexName}:postDate:desc`,
      ...filters,
    }
  });

  instantsearchInstances[indexName] = search;
});

// update other index result
function updateOtherIndex(searchKeyword, currentIndexName, filters) {
  Object.keys(instantsearchInstances).forEach((key) => {
    if (key !== currentIndexName) {
      instantsearchInstances[key].setUiState({
        [key]: {
          query: searchKeyword,
          page: 1,
          sortBy: `${key}:postDate:desc`,
          ...filters,
        }
      });
    }
  })
}